import { render, staticRenderFns } from "./contrasena.vue?vue&type=template&id=267e16da&lang=html"
import script from "./contrasena.vue?vue&type=script&lang=js"
export * from "./contrasena.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports